import React from 'react';

import { LazyDCScriptMigrationPage } from '@confluence/dc-script-migration/entry-points/DCScriptMigrationPage.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminDCScriptMigrationRoute = () => <LazyDCScriptMigrationPage />;

AdminDCScriptMigrationRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: 'adminDCScriptMigration' },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
